import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fc66ae2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tree-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tree = _resolveComponent("Tree")!
  const _component_MenuDetail = _resolveComponent("MenuDetail")!
  const _component_CosFullLayout = _resolveComponent("CosFullLayout")!

  return (_openBlock(), _createBlock(_component_CosFullLayout, null, {
    aside: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Tree, {
          "tree-data": _ctx.treeData,
          onSelectTreeData: _ctx.selectTreeData,
          onEmptyTreeData: _ctx.emptyTreeData,
          onAddNewService: _ctx.addNewService,
          onSuccessRefresh: _ctx.successRefresh,
          onShowEditEmit: _ctx.showEditEmit
        }, null, 8, ["tree-data", "onSelectTreeData", "onEmptyTreeData", "onAddNewService", "onSuccessRefresh", "onShowEditEmit"])
      ])
    ]),
    main: _withCtx(() => [
      _createVNode(_component_MenuDetail, {
        data: _ctx.selectTreeDataId,
        addData: _ctx.addData,
        showEdit: _ctx.showEdit,
        onSuccessRefresh: _ctx.successRefresh
      }, null, 8, ["data", "addData", "showEdit", "onSuccessRefresh"])
    ]),
    _: 1
  }))
}